<template>
  <div class="content">
    <div class="content_title">
      Мои поселки
    </div>
    <div class="form-row-parse">
      <div class="form-input-parse">
        <label for="user-input">Управляющая компания</label>
        <select id="user-input" v-model="user" @change="getVillages">
          <option v-for="(user, key) in users" :value="user.ID" :key="key">
            {{ user.FIO }}
          </option>
        </select>
      </div>
    </div>
    <div class="content_row col-4" v-show="user">
      <div>Название</div>
      <div>Район</div>
      <div>Регион</div>
    </div>
    <div
      class="content_row col-4"
      v-for="(village, key) in villages"
      :key="key"
    >
      <div>
        {{ village.NAME }}
      </div>
      <div>
        {{ village.DISTRICT_NAME }}
      </div>
      <div>
        {{ village.REGION_NAME }}
      </div>
      <button
        @click="genplanVillage(village.REGION, village.DISTRICT, village.ID)"
      >
        На генплан
      </button>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetVillages",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      user: false,
      users: [],
      url: config.backend_url,
      villages: []
    };
  },
  computed: {},
  watch: {
    updateList: function(state) {
      if (state) {
        this.getVillages();
      }
    }
  },
  methods: {
    genplanVillage: function(region, district, village, addContracts = false) {
      let query = {
        village: village,
        district: district,
        region: region
      };
      if (addContracts) query.addContracts = true;
      this.$router.push({
        name: "Genplan",
        query: query
      });
    },
    getVillages: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "villages/get-user-villages/",
          data: { user: this.user },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            this.villages = data;
            if (this.updateLists) this.$emit("villages-list-update");
          }
        });
    },
    getUsers: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "users/get/",
          data: {},
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) this.users = data;
        });
    }
  },
  created() {
    this.getUsers();
  }
};
</script>
